import {get} from "@/context/context";
import {TimeZoneRepository} from "@/repositories/TimeZoneRepository";
import {TimeZone} from "@/models/TimeZone";
import {RequestConfig} from "@/models/RequestConfig";

export class TimeZoneService {

    public timeZoneRepository: TimeZoneRepository = get('timeZoneRepository');

    public getList(): Promise<TimeZone[]> {
        return this.timeZoneRepository.getList();
    }
}
